import React from "react";
import Button from "../../../../../../_components/Button";
import Text from "../../../../../../_components/Text";
import Modal from "../../../../../../_components/Modal";
import { getNFeHistory } from "../../../../../../api/nfe";
import {
  decimalFormat,
  setLocalStorageItem,
  showSnackBar,
} from "../../../../../../utils";

export default (props) => {
  const [show, setShow] = React.useState(false);

  function onAdaptData(data) {
    data.items = data.items.map((item) => {
      for (let tax of ["icms", "ipi", "pis", "cofins"]) {
        for (let key of Object.keys(item[tax])) {
          if (item[tax][key] && typeof item[tax][key] == "string") {
            if (item[tax][key].includes(".")) {
              item[tax][key] = decimalFormat(item[tax][key], 2);
            }
          }
        }
      }
      return item;
    });
    data.payments = data.payments.map((payment) => {
      const options = { year: "numeric", month: "2-digit", day: "numeric" };
      if (payment.due_date) {
        payment.formattedDueDate = new Date(
          payment.due_date
        ).toLocaleDateString("pt-BR", options);
      }
      return payment;
    });
    return data;
  }
  function onShow() {
    setShow(true);
    getNFeHistory(props.nfe.id)
      .then((data) => {
        try {
          data = onAdaptData(data);
          setLocalStorageItem("nfe", data);
          setTimeout(() => (window.location.href = "/nfe/issuer"), 500);
        } catch (error) {
          showSnackBar(error);
          setShow(false);
        }
      })
      .catch();
  }
  function onHide() {
    setShow(false);
  }
  return (
    <React.Fragment>
      <Button
        onClick={onShow}
        as="text"
        className="text-info mx-1"
        title="Duplicar NF-e"
      >
        <i className="fas fa-share-square" /> <span>Duplicar NF-e</span>
      </Button>
      <Modal title="Duplicar NF-e" show={show} onHide={onHide}>
        <Text className="text-center py-3">
          Aguarde um momento, por favor...
        </Text>
      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/DuplicateNFe/index.jsx